import React from 'react';
import {
  Flex,
  Box,
  Heading,
  Text,
  HStack,
  Select,
  Button,
} from '@chakra-ui/react';
import { FiRefreshCw } from 'react-icons/fi';

/**
 * DashboardHeader - Component for the dashboard header with title and controls
 * 
 * @param {Object} props - Component props
 * @param {string} props.timeFrame - Selected time frame
 * @param {Function} props.onTimeFrameChange - Handler for time frame changes
 * @param {Function} props.onRefresh - Handler for refresh button click
 */
const DashboardHeader = ({ timeFrame, onTimeFrameChange, onRefresh }) => {
  return (
    <Flex justify="space-between" align="center" mb={6}>
      <Box>
        <Heading size="lg">Dashboard de Suporte</Heading>
        <Text color="gray.500">Acompanhamento de atendimentos e satisfação de clientes</Text>
      </Box>
      <HStack>
        <Text mr={2}>Período:</Text>
        <Select value={timeFrame} onChange={onTimeFrameChange} w="150px">
          <option value="day">Hoje</option>
          <option value="week">Esta Semana</option>
          <option value="month">Este Mês</option>
          <option value="quarter">Este Trimestre</option>
          <option value="year">Este Ano</option>
        </Select>
        <Button 
          leftIcon={<FiRefreshCw />} 
          colorScheme="yellow" 
          variant="outline"
          onClick={onRefresh}
        >
          Atualizar
        </Button>
      </HStack>
    </Flex>
  );
};

export default DashboardHeader;